import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

function Footer() {
  useEffect(() => {
    gsap.fromTo(
      ".footer-bg",
      { opacity: 0 },
      {
        opacity: 1,
        duration: 0.5,
        scrollTrigger: {
          trigger: ".footer",
          start: "top 50%",
          toggleActions: "restart reverse resume reverse",
        },
      }
    );
  }, []);

  return (
    <footer className="footer ">
      <div className="footer-bg "> </div>
      <footer className="inner container">
        <div className="f-top">
          <div className="f-inner">
            <div className="col-1">
              <h2>Our exciting </h2>
              <h2 className="cambon_font">journey awaits you.</h2>
            </div>
            <div className="col-2">
              <div className="link-item">
                <Link className="animateLine" to="/contact">
                  Contact
                </Link>
              </div>
              {/* <div className="link-item">
                                <Link className='animateLine' to="/jobs">Jobs</Link>
                            </div> */}
            </div>
          </div>
        </div>
        <div className="f-bottom">
          <div className="copyright col-1">
            <p>&#169; TechFreelanceX 2023</p>
          </div>
          <div className="f-links col-w">
            <ul>
              {/* <li><Link to="/certificate">Certificate</Link></li> */}
              <li>
                <Link to="/private-policies">Privacy</Link>
              </li>
              <li>
                <Link
                  target="_blank"
                  to="https://www.instagram.com/techfreelancex/"
                >
                  Instagram
                </Link>
              </li>
              <li>
                <Link
                  target="_blank"
                  to="https://www.youtube.com/channel/UCTRStOGr-lcX40TRlD5Y5fg"
                >
                  Youtube
                </Link>
              </li>
              <li>
                <Link
                  target="_blank"
                  to="https://www.linkedin.com/in/techfreelancex-60b475268/"
                >
                  LinkedIn
                </Link>
              </li>
            </ul>
          </div>
          <div className="our_magazine col-3">
            <p>
              <Link className="animateLine" to="/our-magazine">
                Seek + Find
              </Link>
            </p>
          </div>
        </div>
      </footer>
    </footer>
  );
}

export default Footer;
